import {commonEnvironment} from './common-environment';

export const environment = {
  production: true,
  SSR_MAIN_APP_PORT: 8084,
  API_URL: 'https://api.mundodocodigo.com.br/api/',
  IMAGES_URL: 'https://api.mundodocodigo.com.br/storage/',
  ...commonEnvironment
};
